// // local
// export const domain = "http://127.0.0.1:8000/api/";
// export const domainV2 = "http://127.0.0.1:8000/api2/";
// export const imageDomain = "http://127.0.0.1:8000/storage/";

// // server test
export const domain = "https://cpcr-api.ksta.co/api/";
export const domainV2 = "http://acaapi.ksta.co/api2/";
export const imageDomain = "https://cpcr-api.ksta.co/storage/";
export const adminDomain = "https://cpcr-admin.ksta.co/";

// // server uat
// export const domain = "https://cpcr-api-uat.ksta.co/api/";
// export const domainV2 = "https://cpcr-api-uat.ksta.co/api2/";
// export const imageDomain = "https://cpcr-api-uat.ksta.co/storage/";
// export const adminDomain = "https://cpcr-admin-uat.ksta.co/";
// export const wpDomain = "https://cpcr-wp-uat.ksta.co/";

// Server Prod
// export const domain = "https://elearningapi.ordpmk.com/api/";
// export const domainV2 = "https://elearningapi.ordpmk.com/api2/";
// export const imageDomain = "https://elearningapi.ordpmk.com/storage/";
